import { SUPPLIER_EVENT_BOOKING_STEPS, SupplierEventBookingStep } from '@bridebook/ui';

/**
 * Re-export the shared step constants so the rest of the web codebase
 * can keep importing from this file without changing every import.
 */
export const BOOKING_STEPS = SUPPLIER_EVENT_BOOKING_STEPS;

export type BookingStepType = SupplierEventBookingStep;

/** Value for ?schedule= that means "show the event selector screen" */
export const SCHEDULE_EVENTS_PARAM = 'events';

/** Value for ?event= that means "show all events / event selector screen" */
export const EVENT_ALL_PARAM = 'all';

/** Marks a showround deep-link created by the logged out signup flow */
export const SIGNUP_FLOW_PARAM = 'fromSignup';
